import React, { useContext } from "react";
import styles from "./Images1.module.scss";
import { Context } from "../../Store";
import { motion } from "framer-motion";

const Images1 = (props) => {
  const { dir, variants1 } = useContext(Context);
  const { experiencesRes, start } = props;

  return (
    <motion.section
      variants={variants1}
      initial="hidden"
      animate="showComponets"
      id={styles.addProduct}
    >
      <div className={styles.container}>
        <div className={styles.item0}>
          <h3>{experiencesRes[start]?.subTitle}</h3>
          <p>{experiencesRes[start]?.desc}</p>
        </div>
        <div className={styles.item1}>
          {experiencesRes[start]?.images.map((image, i) => (
            <img
              className={
                dir === "ltr" ? styles.addProduct0l : styles.addProduct0r
              }
              src={image.image}
              alt=""
              key={i}
            />
          ))}
          {/* <img
            className={
              dir === "ltr" ? styles.addProduct0l : styles.addProduct0r
            }
            src={experiencesRes[start]?.images[0]}
            alt=""
          /> */}
        </div>
      </div>
    </motion.section>
  );
};

export default Images1;
